import styled from "styled-components"
import Img from "gatsby-image"

export const HeroImg = styled(Img)`
  border-radius: 4px;
  box-shadow: 0 13px 27px -5px hsla(240, 30.1%, 28%, 0.25),
    0 8px 16px -8px hsla(0, 0%, 0%, 0.4), 0 -6px 16px -6px hsla(0, 0%, 0%, 0.04);
`
